/**
     * @desc 报价
通过合约对NFT报价后，将报价信息保存到后端
id：通过/system/getId获得，用于监听合约，数据唯一标识
price：报价价格
bidder：报价人钱包地址
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/bid', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/bid', params);
}
